import translator from 'src/translate'
import { withStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import styles from '../styles'
import {
  Typography,
  Box,
  Switch,
  FormControlLabel,
  FormGroup,
  CircularProgress,
} from '@material-ui/core'

import { useCourseSettings } from 'src/hooks/useCourseSettings'

import { Icon } from '@iconify/react'
import { CoreButton, CoreTextField } from 'src/components/core'
import UserType from 'src/model/user-types'
const SETTING_KEY = 'webhookAnswer'
const Webhook = props => {
  const { classes } = props
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)

  // Webhooks start at Pro v2. The Basic-only check below predates the Plus
  // plan, which is paid but doesn't include webhooks.
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const isUserPremium =
    Number(window.CONSTANTS.USER_ROLE_ID) !== 1 && userControl !== 'Plus'
  const [loading, setLoading] = useState(false)

  const [endpointUrl, setEndpointUrl] = useState(exists ? value.url : '')

  const [cardEnd, setCardEnd] = useState(
    exists ? value.triggers[0].isActive : false,
  )
  const [courseEnd, setCourseEnd] = useState(
    exists ? value.triggers[1].isActive : false,
  )

  const saveSettings = e => {
    setLoading(true)
    let triggers = [
      {
        trigger: 0,
        isActive: cardEnd,
      },
      { trigger: 1, isActive: courseEnd },
    ]
    let variables = {
      url: endpointUrl,
      isActive: true,
      triggers,
    }

    if (!exists) {
      // create a setting entity with execute function
      execute(variables, () => setLoading(false))
    } else {
      update(variables, () => setLoading(false))
    }
    setTimeout(() => setLoading(false), 1000)
  }
  return (
    <form className={classes.content}>
      <Box m={1}></Box>
      <CoreTextField
        type="text"
        id="endpointUrl"
        variant="outlined"
        label={translator._('assignment.courseSettings.endpointUrl')}
        defaultValue={endpointUrl}
        onBlur={event => setEndpointUrl(event.target.value)}
        disabled={isUserPremium ? false : true}
      />
      <Box m={1}></Box>
      <Typography variant="body1" style={{ fontWeight: 600 }}>
        {translator._('assignment.courseSettings.event')}
      </Typography>
      <Box m={0.5}></Box>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              id="cardEnd"
              checked={cardEnd}
              onChange={() => setCardEnd(!cardEnd)}
              disabled={isUserPremium ? false : true}
            />
          }
          label={translator._('assignment.courseSettings.card')}
        />
      </FormGroup>
      <Box m={0.25}></Box>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              id="courseEnd"
              checked={courseEnd}
              onChange={() => setCourseEnd(!courseEnd)}
              disabled={isUserPremium ? false : true}
            />
          }
          label={translator._('assignment.courseSettings.course')}
        />
      </FormGroup>

      {loading ? (
        <div className={classes.bottomButton}>
          <CircularProgress></CircularProgress>
        </div>
      ) : isUserPremium ? (
        <div className={classes.bottomButton}>
          <CoreButton
            fullWidth={true}
            color="success"
            size="small"
            variant="contained"
            onClick={() => saveSettings()}
          >
            {translator._('assignment.courseSettings.save')}
          </CoreButton>
        </div>
      ) : (
        <div className={classes.bottomButton}>
          <CoreButton
            fullWidth={true}
            to="/pricing"
            color="primary"
            variant="contained"
            startIcon={
              <Icon size="small" icon="fa6-solid:crown" color="#f7b155"></Icon>
            }
            component={RouterLink}
          >
            Upgrade to Edit
          </CoreButton>
        </div>
      )}
    </form>
  )
}

export default withStyles(styles)(Webhook)
